<template>
    <v-row class="cards_information_type_b2b d-flex justify-space-between">
        <v-col v-for="card in cardOptions" :key="card.cardId" class="container_cards" cols="12" sm="4">
            <router-link :to="{ name: `${card.url}`, params: { request: `${card.request ? card.request : ''}`, id: `${card.id ? card.id : ''}`} }" class="router_link_class">
                <v-card class="div_card_options d-flex flex-column" :style="`background: url(${card.backgroundImage})`">
                    <div class="subcard_div d-flex flex-column">
                        <span class="white--text d-flex flex-column">
                            <img class="card_img" :src="card.icon" alt="card_icon" onload="SVGInject(this)" />
                            {{ card.title }}
                        </span>
                    </div>
                </v-card>
            </router-link>
        </v-col>
    </v-row>
</template>

<script>
export default {

    /** @param example
        cardOptions = [
            { title: 'Manuais Técnicos', icon: '/images/_SVGs/manuais.svg', backgroundImage: '/images/_SVGs/manuais_bg.svg', url: 'tech-manuals', cardId: 1 },
            { title: 'Dados Técnicos', icon: '/images/_SVGs/dados_tecnicos2.svg', backgroundImage: '/images/_SVGs/dados_bg.svg', url: 'tech-data', cardId: 2},
            { title: 'Tempos de Reparação', icon: '/images/_SVGs/intervalos_hora.svg', backgroundImage: '/images/_SVGs/tempos_bg.svg', url: 'repair-times', cardId: 3 },
        ];
     */

    props: {
        cardOptions: {
            type: [Array, Object],
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.cards_information_type_b2b {
    .router_link_class {
        color: transparent !important;
    }

    .container_cards {
        width: 100%;

        .div_card_options {
            background-repeat: no-repeat !important;
            background-size: cover !important;
            height: 100px;
            border-radius: 10px;

            .subcard_div {
                padding-left: 85px;
                .card_img {
                    color: white;
                    height: 40px;
                    margin-top: 8px;
                    align-self: end;
                    margin-left: -3px;
                }

                span {
                    font-size: 20px;
                    font-weight: 500;
                }
            }
        }
    }
}

@media (max-width: $md) {
    .cards_information_type_b2b {
        .subcard_div {
            padding-left: 40px !important;
            .card_img {
                margin-top: 12px !important;
            }
            span {
                font-size: 16px !important;
            }
        }
    }
}

@media (max-width: $xs) {
    .cards_information_type_b2b {
        .subcard_div {
            padding-left: 80px !important;
            .card_img {
                margin-top: 8px !important;
            }
            span {
                font-size: 20px !important;
            }
        }
    }
}
</style>
